import { AnyAction } from 'redux'
import { produce } from 'immer'
import { PaginateRequest, PaginateResponse } from '../../services/api.service'
import { PalletData, PalletStatus } from '../../apis/pallet.api'
import palletService from '../../services/pallet.service'
import { ActionName } from '../../components/Actions'

interface State extends PaginateRequest {
  result: PaginateResponse<PalletData[]>
  search: string
  status: PalletStatus
  startAt: string
  endAt: string
  item: string
  workOrder: string
  code: string
}

const initialState: State = {
  result: {
    data: [],
    total: 0,
    from: null,
    to: null,
    currentPage: 0,
    lastPage: 0,
  },
  page: 1,
  limit: 25,
  search: '',
  status: 'inventory',
  startAt: '',
  endAt: '',
  item: '',
  workOrder: '',
  code: ''
}

export const actions = {
  replaceResult: 'inventories/replaceResult',
  replaceResultData: 'inventories/replaceResultData',
  replacePage: 'inventories/replacePage',
  replaceLimit: 'inventories/replaceLimit',
  replaceSearch: 'inventories/replaceSearch',
  replaceStatus: 'inventories/replaceStatus',
  replaceFilter: 'inventories/replaceFilter',
  replaceSelectedItem: 'inventories/replaceSelectedItem',
  replaceSelectedWorkOrder: 'inventories/replaceSelectedWorkOrder',
  replaceLPN: 'inventories/replaceLPN',
  replaceAllFilters: 'inventories/replaceAllFilters'
}

export function replaceResult (result: State['result']) {
  return { type: actions.replaceResult, result }
}

export function replaceResultData (data: State['result']['data']) {
  return { type: actions.replaceResultData, data }
}

export function replacePage (page: number) {
  return { type: actions.replacePage, page }
}

export function replaceLimit (limit: number) {
  return { type: actions.replaceLimit, limit }
}

export function replaceSearch (search: string) {
  return { type: actions.replaceSearch, search }
}

export function replaceLPN (code: string) {
  return { type: actions.replaceLPN, code }
}

export function replaceSelectedItem (item: string) {
  return { type: actions.replaceSelectedItem, item }
}

export function replaceSelectedWorkOrder (workOrder: string) {
  return { type: actions.replaceSelectedWorkOrder, workOrder }
}

export function replaceAllFilters () {
  return { type: actions.replaceAllFilters }
}

export function replaceStatus (status: PalletStatus) {
  return { type: actions.replaceStatus, status }
}

export function replaceFilter (startAt: string, endAt: string) {
  return { type: actions.replaceFilter, startAt, endAt }
}

export default function reducers (state = initialState, action: AnyAction) {
  switch (action.type) {
    case actions.replaceResult: {
      return produce(state, draft => {
        draft.result = action.result
        const { status } = draft
        const baseActions: ActionName[] = ['print', 'rollback', 'delete']
        const actions: ActionName[] = (status !== 'bare')
          ? ['view', 'history', ...baseActions]
          : baseActions
        draft.result.data = palletService.tableHorizontalData(action.result.data, actions)
      })
    }
    case actions.replaceResultData:
      return produce(state, draft => {
        draft.result.data = action.data
      })
    case actions.replacePage:
      return produce(state, draft => {
        draft.page = action.page
      })
    case actions.replaceLimit:
      return produce(state, draft => {
        draft.limit = action.limit
      })
    case actions.replaceSearch:
      return produce(state, draft => {
        draft.search = action.search
      })
    case actions.replaceLPN:
      return produce(state, draft => {
        draft.code = action.code
      })
    case actions.replaceSelectedItem:
      return produce(state, draft => {
        draft.item = action.item
      })
    case actions.replaceSelectedWorkOrder:
      return produce(state, draft => {
        draft.workOrder = action.workOrder
      }) 
    case actions.replaceAllFilters:
      return produce(state, draft => {
        draft.workOrder = ""
        draft.code = ""
        draft.item = ""
        draft.endAt = ""
        draft.search = ""
        draft.startAt = ""
        draft.status = 'inventory'

      })   
    case actions.replaceStatus:
      return produce(state, draft => {
        draft.status = action.status
      })
    case actions.replaceFilter:
      return produce(state, draft => {
        draft.startAt = action.startAt
        draft.endAt = action.endAt
      })
    default:
      return state
  }
}
